module.exports = __webpack_public_path__ + "static/media/charles.378ffdb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/charles.png
// module id = 81
// module chunks = 0